import styled from 'styled-components';
import { Link } from '@latitude/link';
import { Heading5 } from '@latitude/heading';
export var StyledHeading = /*#__PURE__*/styled(Heading5).withConfig({
  displayName: "Imagestyled__StyledHeading",
  componentId: "sc-gdroz9-0"
})(["position:absolute;height:100%;width:100%;display:flex;justify-content:center;align-items:center;text-align:center;"]);
export var StyledLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "Imagestyled__StyledLink",
  componentId: "sc-gdroz9-1"
})(["display:inline-block;transition:all 150ms ease-in-out 0s;position:relative;&:hover{box-shadow:rgb(0 0 0 / 40%) 0px 1px 13px 0px;border-bottom:none;text-shadow:none;}"]);
export var StyledImage = /*#__PURE__*/styled.img.withConfig({
  displayName: "Imagestyled__StyledImage",
  componentId: "sc-gdroz9-2"
})(["display:block;height:", ";max-width:100%;width:", ";"], function (_ref) {
  var height = _ref.height;
  return height ? height + "px" : "auto";
}, function (_ref2) {
  var width = _ref2.width;
  return width ? width + "px" : "100%";
});